import buildQuery from "odata-query";
import { ODataParams } from "./odata-params";

export class Query {
  static build(query: ODataParams) {
    return buildQuery({
      key: query.key,
      top: query.top,
      skip: query.skip,
      count: query.count,
      expand: query.expand,
      filter: query.filter,
      orderBy: query.orderBy,
      select: query.select,
      func: query.func,
      action: query.action,
      transform: query.transform
    });
  }
}
